import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import { Image } from "react-bootstrap";

import Button from "../../../../components/UI/Button/Button";
import * as explanationOfBenefitsActions from "../../../../store/actions/index.js";

import uploadImage from "../../../../assets/images/img-upload.png";

import classes from "./BrowseExplanationOfBenefits.module.css";
import { withTranslation } from "react-i18next";

interface IParentProps {
  modalClosed: () => void;
}
interface IStateFromProps {
  explanationOfBenefitsBills: File[];
  t:any;
}

interface IDispatchFromProps {
  onAddExplanationOfBenefitsBills: (fileArray: File[]) => void;
}

type Props = IParentProps & IStateFromProps & IDispatchFromProps;

class BrowseExplanationOfBenefits extends Component<Props> {
  fileObj: File[] = [];
  fileArray: File[] = [];
  state = {
    selectedFilesCount: 0,
  };

  uploadMultipleFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("fileObj in uploadMultipleFiles ", this.fileObj);
    this.fileObj.push(...e.target.files!);
    console.log("fileObj in uploadMultipleFiles ", this.fileObj);
    console.log("targetfiles in uploadMultipleFiles ", ...e.target.files!);
    this.setState({ selectedFilesCount: this.fileObj?.length });
    e.target.value = "";
  };

  uploadFiles = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    this.fileArray = [
      ...this.props.explanationOfBenefitsBills,
      ...this.fileObj,
    ];
    this.props.onAddExplanationOfBenefitsBills([...this.fileArray]);
    this.fileObj = [];
    this.fileArray = [];
    this.setState({ selectedFilesCount: 0 });
    this.props.modalClosed();
  };
  cancelHandler = () => {
    this.fileObj = [];
    this.setState({ selectedFilesCount: 0 });
    console.log("fileObj in cancel ", this.fileObj);
    this.props.modalClosed();
  };

  render() {
    const {t} = this.props;
    const nextBtnStyle = {
      height: "24px",
      lineHeight: "24px",
      fontSize: "12px",
      padding: "0 10px",
      borderRadius: "5px",
      minWidth: "120px",
    };
    return (
      <div className="popupContainer">
        <div className="popupHeader">
          <h6>{t('uploadFile.upload')}</h6>
          <div className="closeBtn" onClick={this.cancelHandler}>
            X
          </div>
        </div>
        <div className="modalBody">
          <Image
            src={uploadImage}
            alt={uploadImage}
            className={classes.browseImage}
          />

          <div className="text-center">
            <label className={[classes.btn, "btn", "btn-default"].join(" ")}>
              <span className={classes.buttonText}>{t('balanceBilling.browseForImg')}</span>
              <input
                type="file"
                className="form-control"
                onChange={(e) => this.uploadMultipleFiles(e)}
                multiple
                accept="image/*,.pdf"
                hidden
              />
            </label>
          </div>
          <div className={classes.selectedFiles}>
            <div>
              {t('uploadFile.fileSelected')}{" "}
              <span className={classes.filesCount}>
                {/* {this.fileObj[0] ? this.fileObj[0].length : "0"} */}
                {this.state.selectedFilesCount}
              </span>
            </div>
          </div>
          <div className={classes.btnGroup}>
            <Button
              label={t('uploadFile.cancelBtn')}
              clicked={this.cancelHandler}
              style={nextBtnStyle}
              displayImg={false}
              image=""
              disabled={false}
            />
            <Button
              label={t('uploadFile.uploadBtn')}
              clicked={this.uploadFiles}
              style={nextBtnStyle}
              displayImg={false}
              image=""
              disabled={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  explanationOfBenefitsBills: state.browseImages.explanationOfBenefitsBills,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onAddExplanationOfBenefitsBills: (fileArray) =>
    dispatch(
      explanationOfBenefitsActions.explanationOfBenefitsBills(fileArray)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BrowseExplanationOfBenefits));
